/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'WeightChart': {
    width: 302,
    height: 50,
    viewBox: '0 0 302 50',
    data: '<defs><linearGradient x1="-28.631%" y1="50%" x2="130.806%" y2="50%" id="svgicon-WeightChart-a"><stop stop-color="#49CAFF" stop-opacity=".525" offset="0%"/><stop stop-color="#FFF" offset="100%"/></linearGradient></defs><g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#CADCFF" opacity=".3" d="M0 13.541h302v23.213H0z"/><path pid="1" _fill="url(#svgicon-WeightChart-a)" d="M0 13.541h231v23.213H0z"/><path pid="2" d="M164 49.328V.968" _stroke="#CADCFF" stroke-linecap="square" stroke-dasharray="3,3,3"/></g>'
  }
})
